import React, { Component } from 'react';
import { Button, Panel } from 'react-bootstrap';
import { each, map, sumBy, indexOf, range } from 'lodash';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import NotificationEmptyState from '../EmptyState/NotificationEmptyState';
import { appBasePath } from '../../constants/staticData';

export default class NotificationView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationSelected: false,
      isNotificationsLoaded: false
    };
  }
  componentWillMount() {
    if ((!this.props.commonReducer.isNotificationsLoaded) && window.location.pathname != appBasePath + '/notification') {
      this.props.actions.getNotificationAlerts(5, 0);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer && nextProps.commonReducer.isNotificationsLoaded && !this.state.isNotificationsLoaded) {
      this.setState({
        'isNotificationsLoaded': true
      });
    }
  }
  render() {
    const {
        commonReducer,
      actions
      } = this.props;
    let unReadNotifications = 0;
    let notificationsData = [];
    let allNotification = [];
    const services = {
      1: 'wash',
      2: 'repair',
      3: 'service',
      4: 'emergency service'
    };

    if (commonReducer.notifications && commonReducer.notifications.length) {
      allNotification = commonReducer.notifications.filter((notification) => {
       // console.log("notification.bookingId",notification);

        return (notification && (notification.bookingId && notification.bookingId.substring(0,3) != 'EMG') || (notification.type === 'Job For The Day'));
      });
    }
    if (allNotification.length > 5) {
      each(range(0, 5), (index) => {
        notificationsData.push(allNotification[index]);
      });
    } else {
      notificationsData = allNotification;
    }
    const notificationsView = map(notificationsData, (message, key) => {
      if (message && !message.isRead) {
        if(!message.service || (message.service != 4 && message.service && !isNaN(message.service))){
          let messageRead = false;
          if (indexOf(commonReducer.markedNotifications, message.alertId) > -1) {
            messageRead = true;
          } else {
            unReadNotifications += 1;
          }
          let serviceType = '';
          if (message.service) {
            serviceType = services[message.service];
          }
          else if (message.bookingId){
            if (message.bookingId.indexOf('WSH') > -1){
              serviceType = 'wash';
            } else if (message.bookingId.indexOf('REP') > -1){
              serviceType = 'repair';
            }
            else if (message.bookingId.indexOf('SRV') > -1){
              serviceType = 'service';
            }
          }
          else if (message.type === 'Job For The Day') {
            serviceType = 'jobToday';
          }
          return (
            <div key={key} onClick={(e) =>
                {
                  e.preventDefault();
                  this.setState({'notificationSelected': false});
                  if (message && message.bookingId) {
                    this.props.router.push(`${appBasePath}/job/${message.requestId}`);
                  }
                  else {
                    this.props.router.push(`${appBasePath}/open-jobs/applied`);
                  }
                  if (!messageRead) { actions.markNotificationAsRead(message.alertId) }
                }
              }
              className={"alert-card " + serviceType} style={{ backgroundColor: messageRead ? '#F9FBFB' : '#FFFFFF' }}>
              <span className={"alert-color " + serviceType}></span>
              <h5 className="alert-text">{message.msg}</h5>
              {message.urgent && <i className="mdi mdi-timer-sand" />}
            </div>
          )
      }
   }
    });
    return (
      <li onClick={this.props.notiClick} className={this.state.notificationSelected ? "notification-menu notify-bell-icon desktop-view pad-align active" : "notification-menu notify-bell-icon pad-align desktop-view"}>
        <div className="text-dropdown notify business notification" >
          <DropdownButton bsSize="large" className="" id="dropdown-size-large" noCaret onToggle={() => { this.setState({ notificationSelected: !this.state.notificationSelected }) }} title={
            <div className="">
              <i className="mdi mdi-bell" aria-hidden="true" />
              {commonReducer.totalUnreadAlerts ? <span className="no-notify"></span> : ''}
            </div>} >
            <MenuItem eventKey="Notifications">
              Notifications
                <a onClick={()=>this.props.router.push(`${appBasePath}/notification`)} className="view_all">View All</a>
            </MenuItem>
            <div className="desk-notify">
              {this.state.isNotificationsLoaded ?
                commonReducer.unableToFetchNotifications
                  ? <div><h3 className="unable-message-notes">Unable to fetch notifications <a style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault; this.props.actions.getNotificationAlerts(5) }}>Try Again</a></h3></div>
                  : (commonReducer.notifications && commonReducer.notifications.length > 0) ? notificationsView : <NotificationEmptyState />
                : <div><h3 className="msg-empty-state">Loading...</h3></div>}
            </div>
          </DropdownButton>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NotificationView.jsx